import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import FranchiseForm from "./FranchiseForm";
import DirectCalendar from "./DirectCalendar";
import { initializeEffects } from "./effects";
export default function LandingContent({ live = false }: { live?: boolean }) {
  const root = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const [withoutForm, setWithoutForm] = useState<boolean | null>(null);
  useEffect(() => {
    if (router.isReady) setWithoutForm(new URLSearchParams(window.location.search).get("") === "wof");
  }, [router.isReady, router.asPath]);
  useEffect(
    () => (root.current ? initializeEffects(root.current) : undefined),
    [],
  );
  return (
    <div className="franchise-landing" lang="es-DO" ref={root}>
      <a className="skip" href="#reunion">
        Ir directo a solicitar la reunión
      </a>

      <header className="hdr" id="hdr">
        <div className="hdr-in">
          <a
            className="logo-dark"
            href="https://www.remaxrd.com/"
            aria-label="REMAX República Dominicana · inicio"
          >
            <img
              src="/franquicias/img/logo-remax-neg.webp"
              alt="REMAX República Dominicana"
              width="1797"
              height="536"
              decoding="async"
            />
          </a>
          <nav className="hdr-nav" aria-label="Navegación principal">
            <a className="lnk" href="#modelo">
              El modelo
            </a>
            <a className="lnk" href="#perfil">
              ¿Es para ti?
            </a>
            <a className="lnk" href="#incluye">
              Qué recibes
            </a>
            <a className="lnk" href="#camino">
              El camino
            </a>
            <a className="btn btn-1 btn-sm" href="#reunion">
              Solicita tu reunión
            </a>
          </nav>
        </div>
      </header>

      <main id="top">
        <section className="hero">
          <div className="hero-bg" aria-hidden="true">
            <img
              src="/franquicias/img/hero-bg.webp"
              alt=""
              width="2400"
              height="1350"
              {...{ fetchpriority: "high" }}
              srcSet="/franquicias/img/hero-bg-480.webp 480w, /franquicias/img/hero-bg-800.webp 800w, /franquicias/img/hero-bg-1200.webp 1200w"
              sizes="100vw"
              decoding="async"
            />
          </div>
          <div className="hero-glow" aria-hidden="true"></div>

          <div
            className="wrap"
            style={{ position: "relative", zIndex: "1" } as React.CSSProperties}
          >
            <div className="hero-top">
              <span className="logo-dark">
                <img
                  src="/franquicias/img/logo-remax-neg.webp"
                  alt="REMAX República Dominicana"
                  width="1797"
                  height="536"
                  decoding="async"
                />
              </span>
              <span className="hero-tag">
                Franquicias · República Dominicana
              </span>
            </div>

            <div className="hero-mid">
              <h1 className="sr">
                Tú diriges tu propia oficina REMAX. Franquicias REMAX en
                República Dominicana.
              </h1>

              <div className="la-anim" id="laAnim" data-rv-clip="">
                <svg
                  className="la"
                  viewBox="520 338 876 406"
                  fill="currentColor"
                  role="img"
                  aria-label="Tú diriges. REMAX respalda."
                  focusable="false"
                >
                  <defs>
                    <clipPath id="laBand">
                      <rect x="500" y="425" width="920" height="260"></rect>
                    </clipPath>
                  </defs>

                  <g className="la-icon">
                    <polygon points="674.99 419.24 652.04 419.36 669.55 359.99 692.43 359.99 674.99 419.24"></polygon>
                    <path d="M622.1,361.91l10.33-.09-.28,34.93c-.11,14.3-11.38,22.62-24.64,22.62-13.34,0-24.55-8.28-24.65-22.62l-.25-34.92h10.48s.32,35.27.32,35.27c.07,8.13,6.55,12.93,14.13,12.99,7.1.06,14.07-4.61,14.16-12.49l.4-35.68Z"></path>
                    <polygon points="556.21 418.27 545.58 418.4 545.6 370.71 526.97 370.61 526.79 361.71 574.88 361.71 574.68 370.64 556.16 370.67 556.21 418.27"></polygon>
                    <path d="M610.48,356.31c-1.7,1.36-6.98.88-9.15.4l10.59-10.96,11.05.59-12.49,9.97Z"></path>
                  </g>

                  <g clipPath="url(#laBand)">
                    <g className="la-w la-w--l">
                      <path d="M573.59,477.76v150.87h-45.26v-150.87h45.26Z"></path>
                      <path d="M639.24,513.65v114.99h-45.26v-114.99h45.26Z"></path>
                      <path d="M659.73,539.64c4.14-8.9,9.82-15.7,17.02-20.39,7.2-4.69,15.29-7.03,24.26-7.03,7.47,0,13.9,1.53,19.27,4.59,5.37,3.06,9.48,7.24,12.33,12.54v-51.58h45.26v150.87h-45.26v-15.7c-2.85,5.3-6.97,9.48-12.33,12.54-5.37,3.06-11.79,4.59-19.27,4.59-8.97,0-17.06-2.34-24.26-7.03-7.21-4.69-12.88-11.48-17.02-20.39-4.15-8.9-6.22-19.4-6.22-31.5s2.07-22.6,6.22-31.5ZM728.13,556.87c-3.13-3.4-7.14-5.1-12.03-5.1s-8.9,1.7-12.03,5.1c-3.13,3.4-4.69,8.16-4.69,14.27s1.56,10.88,4.69,14.27c3.12,3.4,7.14,5.1,12.03,5.1s8.9-1.7,12.03-5.1c3.12-3.4,4.69-8.16,4.69-14.27s-1.56-10.87-4.69-14.27Z"></path>
                      <path d="M908.98,579.09h-72.79c.68,9.92,4.82,14.88,12.44,14.88,4.89,0,8.43-2.24,10.6-6.73h47.91c-1.63,8.16-5.07,15.46-10.3,21.92-5.23,6.46-11.83,11.55-19.78,15.29-7.95,3.74-16.69,5.61-26.2,5.61-11.42,0-21.58-2.38-30.48-7.14-8.9-4.76-15.84-11.59-20.8-20.49-4.96-8.9-7.44-19.33-7.44-31.3s2.48-22.39,7.44-31.3c4.96-8.9,11.89-15.73,20.8-20.49,8.9-4.76,19.06-7.14,30.48-7.14s21.58,2.34,30.48,7.03c8.9,4.69,15.83,11.39,20.8,20.08,4.96,8.7,7.44,18.96,7.44,30.79,0,3.13-.2,6.12-.61,8.97ZM863.71,559.32c0-3.8-1.22-6.69-3.67-8.67-2.45-1.97-5.5-2.96-9.17-2.96-8.02,0-12.71,3.87-14.07,11.62h26.91Z"></path>
                      <path d="M986.04,518.85c6.66-4.01,13.59-6.01,20.8-6.01v48.32h-12.84c-8.56,0-14.85,1.5-18.86,4.49-4.01,2.99-6.01,8.29-6.01,15.9v47.1h-45.26v-114.99h45.26v21.2c4.62-6.66,10.26-11.99,16.92-16Z"></path>
                      <path d="M1019.17,539.64c4.14-8.9,9.82-15.7,17.02-20.39,7.2-4.69,15.29-7.03,24.26-7.03,7.47,0,13.93,1.53,19.37,4.59,5.43,3.06,9.58,7.24,12.44,12.54v-15.7h45.06v114.99h-45.06v-15.7c-2.85,5.3-7,9.48-12.44,12.54-5.44,3.06-11.9,4.59-19.37,4.59-8.97,0-17.06-2.34-24.26-7.03-7.21-4.69-12.88-11.48-17.02-20.39-4.15-8.9-6.22-19.4-6.22-31.5s2.07-22.6,6.22-31.5ZM1087.57,556.87c-3.13-3.4-7.14-5.1-12.03-5.1s-8.9,1.7-12.03,5.1c-3.13,3.4-4.69,8.16-4.69,14.27s1.56,10.88,4.69,14.27c3.12,3.4,7.14,5.1,12.03,5.1s8.9-1.7,12.03-5.1c3.13-3.4,4.69-8.16,4.69-14.27s-1.56-10.87-4.69-14.27Z"></path>
                      <path d="M1180.03,624.76c-8.36-3.53-14.99-8.43-19.88-14.68-4.89-6.25-7.68-13.32-8.36-21.2h43.43c.54,3.4,2,5.91,4.38,7.54,2.38,1.63,5.4,2.45,9.07,2.45,2.31,0,4.14-.51,5.5-1.53,1.36-1.02,2.04-2.27,2.04-3.77,0-2.58-1.43-4.42-4.28-5.5-2.85-1.09-7.68-2.31-14.48-3.67-8.29-1.63-15.12-3.4-20.49-5.3-5.37-1.9-10.06-5.16-14.07-9.79-4.01-4.62-6.01-11.01-6.01-19.16,0-7.07,1.87-13.49,5.61-19.27,3.74-5.78,9.28-10.33,16.62-13.66,7.34-3.33,16.24-5,26.71-5,15.5,0,27.63,3.81,36.39,11.42,8.77,7.61,14.03,17.53,15.8,29.77h-40.16c-.68-3.12-2.11-5.54-4.28-7.24-2.18-1.7-5.1-2.55-8.77-2.55-2.31,0-4.08.44-5.3,1.32-1.22.89-1.83,2.21-1.83,3.98,0,2.31,1.43,4.05,4.28,5.2,2.85,1.16,7.41,2.34,13.66,3.57,8.29,1.63,15.29,3.47,21,5.5s10.67,5.54,14.88,10.5c4.21,4.96,6.32,11.79,6.32,20.49,0,6.8-1.97,12.92-5.91,18.35-3.94,5.44-9.62,9.72-17.02,12.84-7.41,3.13-16.07,4.69-26,4.69-10.88,0-20.49-1.76-28.85-5.3Z"></path>
                      <path d="M1279.22,623.95c-4.76-4.21-7.14-9.51-7.14-15.9s2.38-11.93,7.14-16.21c4.76-4.28,11.08-6.42,18.96-6.42s14,2.14,18.76,6.42c4.76,4.28,7.14,9.68,7.14,16.21s-2.38,11.69-7.14,15.9c-4.76,4.21-11.01,6.32-18.76,6.32s-14.21-2.11-18.96-6.32Z"></path>
                      <g transform="translate(616.61 477.76)">
                        <g className="la-breathe">
                          <circle
                            className="la-kick la-dot--r"
                            r="28.03"
                          ></circle>
                        </g>
                      </g>
                    </g>

                    <g className="la-w la-w--g">
                      <g transform="translate(2.09 7.99) scale(0.993033)">
                        <path d="M581.49,496.88c4.19,2.36,7.39,5.58,9.59,9.67v-12.1h34.74v87.08c0,8.28-1.52,15.82-4.56,22.64-3.04,6.81-7.94,12.26-14.7,16.35s-15.43,6.13-26.02,6.13c-14.25,0-25.54-3.33-33.87-9.98-8.33-6.66-13.07-15.7-14.23-27.12h34.27c.94,4.61,4.72,6.92,11.32,6.92,4.09,0,7.28-1.05,9.59-3.14,2.3-2.1,3.46-6.03,3.46-11.79v-10.53c-2.2,4.09-5.4,7.31-9.59,9.67-4.19,2.36-9.17,3.54-14.93,3.54-6.92,0-13.15-1.81-18.71-5.42-5.56-3.62-9.93-8.85-13.13-15.72-3.2-6.86-4.79-14.96-4.79-24.29s1.6-17.42,4.79-24.29c3.2-6.86,7.57-12.1,13.13-15.72,5.55-3.62,11.79-5.42,18.71-5.42,5.76,0,10.74,1.18,14.93,3.54ZM587.47,527.76c-2.41-2.62-5.5-3.93-9.27-3.93s-6.87,1.31-9.27,3.93c-2.41,2.62-3.62,6.29-3.62,11s1.2,8.38,3.62,11c2.41,2.62,5.5,3.93,9.27,3.93s6.86-1.31,9.27-3.93c2.41-2.62,3.62-6.29,3.62-11s-1.21-8.38-3.62-11Z"></path>
                        <path d="M726.89,544.9h-56.12c.52,7.65,3.72,11.47,9.59,11.47,3.77,0,6.5-1.73,8.17-5.19h36.94c-1.26,6.29-3.91,11.92-7.94,16.9-4.04,4.98-9.12,8.91-15.25,11.79-6.13,2.88-12.86,4.32-20.2,4.32-8.8,0-16.64-1.83-23.5-5.5-6.86-3.67-12.21-8.93-16.03-15.8-3.83-6.86-5.74-14.91-5.74-24.13s1.91-17.26,5.74-24.13c3.82-6.86,9.17-12.13,16.03-15.8,6.86-3.67,14.7-5.5,23.5-5.5s16.64,1.81,23.5,5.42c6.86,3.62,12.21,8.78,16.03,15.48,3.82,6.71,5.74,14.62,5.74,23.74,0,2.41-.16,4.72-.47,6.92ZM692,529.65c0-2.93-.94-5.16-2.83-6.68-1.89-1.52-4.24-2.28-7.07-2.28-6.18,0-9.8,2.99-10.85,8.96h20.75Z"></path>
                        <path d="M755.58,580.11c-6.44-2.72-11.55-6.5-15.33-11.32-3.77-4.82-5.92-10.27-6.44-16.35h33.48c.42,2.62,1.54,4.56,3.38,5.82,1.83,1.26,4.17,1.89,7,1.89,1.78,0,3.2-.39,4.24-1.18,1.05-.79,1.57-1.75,1.57-2.91,0-1.99-1.1-3.4-3.3-4.24-2.2-.84-5.92-1.78-11.16-2.83-6.39-1.26-11.66-2.62-15.8-4.09-4.14-1.47-7.76-3.98-10.85-7.54-3.09-3.56-4.64-8.49-4.64-14.78,0-5.45,1.44-10.4,4.32-14.85,2.88-4.45,7.15-7.96,12.81-10.53,5.66-2.57,12.52-3.85,20.59-3.85,11.95,0,21.3,2.94,28.06,8.8,6.76,5.87,10.82,13.52,12.18,22.95h-30.97c-.53-2.41-1.63-4.27-3.3-5.58-1.68-1.31-3.93-1.96-6.76-1.96-1.78,0-3.14.34-4.09,1.02-.94.68-1.41,1.7-1.41,3.07,0,1.78,1.1,3.12,3.3,4.01,2.2.89,5.71,1.81,10.53,2.75,6.39,1.26,11.79,2.67,16.19,4.24s8.23,4.27,11.48,8.1c3.25,3.83,4.87,9.09,4.87,15.8,0,5.24-1.52,9.96-4.56,14.15-3.04,4.19-7.42,7.49-13.13,9.9-5.71,2.41-12.39,3.62-20.04,3.62-8.38,0-15.8-1.36-22.24-4.09Z"></path>
                        <path d="M884.55,553.39v29.71h-13.2c-24.31,0-36.47-12.1-36.47-36.31v-23.26h-11v-29.08h11v-21.38h34.9v21.38h14.46v29.08h-14.46v23.89c0,2.1.5,3.62,1.49,4.56.99.94,2.65,1.42,4.95,1.42h8.33Z"></path>
                        <path d="M932.81,494.44v88.66h-34.9v-88.66h34.9Z"></path>
                        <path d="M966.6,578.69c-7.13-3.67-12.71-8.93-16.74-15.8-4.04-6.86-6.05-14.91-6.05-24.13s2.02-17.26,6.05-24.13c4.03-6.86,9.61-12.13,16.74-15.8,7.12-3.67,15.14-5.5,24.05-5.5s16.92,1.83,24.05,5.5c7.12,3.67,12.71,8.94,16.74,15.8,4.03,6.86,6.05,14.91,6.05,24.13s-2.02,17.27-6.05,24.13c-4.04,6.87-9.62,12.13-16.74,15.8-7.13,3.67-15.14,5.5-24.05,5.5s-16.92-1.83-24.05-5.5ZM998.83,550.16c2.2-2.57,3.3-6.37,3.3-11.4s-1.1-8.83-3.3-11.4c-2.2-2.57-4.93-3.85-8.17-3.85s-5.97,1.29-8.17,3.85c-2.2,2.57-3.3,6.37-3.3,11.4s1.07,8.83,3.22,11.4c2.15,2.57,4.9,3.85,8.25,3.85s5.97-1.28,8.17-3.85Z"></path>
                        <path d="M1134.4,504.03c5.71,6.81,8.57,16.03,8.57,27.67v51.4h-34.74v-47c0-4.19-1.13-7.52-3.38-9.98-2.25-2.46-5.27-3.69-9.04-3.69s-6.92,1.23-9.12,3.69c-2.2,2.46-3.3,5.79-3.3,9.98v47h-34.9v-88.66h34.9v13.52c2.72-4.19,6.37-7.6,10.92-10.22,4.56-2.62,9.98-3.93,16.27-3.93,10.16,0,18.1,3.41,23.81,10.22Z"></path>
                        <path d="M1158.14,514.48c3.2-6.86,7.57-12.1,13.12-15.72,5.55-3.62,11.79-5.42,18.71-5.42,5.76,0,10.74,1.18,14.93,3.54,4.19,2.36,7.39,5.58,9.59,9.67v-12.1h34.74v88.66h-34.74v-12.1c-2.2,4.09-5.4,7.31-9.59,9.67-4.19,2.36-9.17,3.54-14.93,3.54-6.92,0-13.15-1.81-18.71-5.42-5.56-3.62-9.93-8.85-13.12-15.72-3.2-6.86-4.79-14.96-4.79-24.29s1.6-17.42,4.79-24.29ZM1210.87,527.76c-2.41-2.62-5.5-3.93-9.27-3.93s-6.87,1.31-9.27,3.93c-2.41,2.62-3.62,6.29-3.62,11s1.2,8.38,3.62,11c2.41,2.62,5.5,3.93,9.27,3.93s6.86-1.31,9.27-3.93c2.41-2.62,3.62-6.29,3.62-11s-1.21-8.38-3.62-11Z"></path>
                        <path d="M1282.16,580.11c-6.45-2.72-11.55-6.5-15.33-11.32-3.77-4.82-5.92-10.27-6.45-16.35h33.48c.42,2.62,1.54,4.56,3.38,5.82,1.83,1.26,4.17,1.89,7,1.89,1.78,0,3.2-.39,4.24-1.18,1.05-.79,1.57-1.75,1.57-2.91,0-1.99-1.1-3.4-3.3-4.24-2.2-.84-5.92-1.78-11.16-2.83-6.39-1.26-11.66-2.62-15.8-4.09-4.14-1.47-7.76-3.98-10.85-7.54-3.09-3.56-4.64-8.49-4.64-14.78,0-5.45,1.44-10.4,4.32-14.85,2.88-4.45,7.15-7.96,12.81-10.53,5.66-2.57,12.52-3.85,20.59-3.85,11.95,0,21.3,2.94,28.06,8.8,6.76,5.87,10.82,13.52,12.18,22.95h-30.97c-.53-2.41-1.63-4.27-3.3-5.58-1.68-1.31-3.93-1.96-6.76-1.96-1.78,0-3.14.34-4.09,1.02-.94.68-1.41,1.7-1.41,3.07,0,1.78,1.1,3.12,3.3,4.01,2.2.89,5.71,1.81,10.53,2.75,6.39,1.26,11.79,2.67,16.19,4.24s8.23,4.27,11.47,8.1c3.25,3.83,4.87,9.09,4.87,15.8,0,5.24-1.52,9.96-4.56,14.15-3.04,4.19-7.42,7.49-13.13,9.9-5.71,2.41-12.39,3.62-20.04,3.62-8.39,0-15.8-1.36-22.24-4.09Z"></path>
                        <path d="M1358.63,579.48c-3.67-3.25-5.5-7.33-5.5-12.26s1.83-9.2,5.5-12.5c3.67-3.3,8.54-4.95,14.62-4.95s10.79,1.65,14.46,4.95c3.67,3.3,5.5,7.47,5.5,12.5s-1.83,9.01-5.5,12.26c-3.67,3.25-8.49,4.87-14.46,4.87s-10.95-1.62-14.62-4.87Z"></path>
                        <g transform="translate(915.36 465.89)">
                          <g className="la-breathe">
                            <circle
                              className="la-kick la-dot--b"
                              r="19.82"
                            ></circle>
                          </g>
                        </g>
                      </g>
                    </g>

                    <g className="la-w la-w--d">
                      <g transform="translate(42.03 35.91) scale(0.933982)">
                        <path d="M1136.27,622.41l13.26-31.94c14.56,7.98,31.1,11.41,47.85,10.12,4.88-.38,8.7-2.98,7.93-5.87-.26-.97-1.86-2.71-2.91-2.89l-14.79-2.55c-18.73-3.24-39.47-3.13-48.02-24.67l-.48,19.83h-81.05c2.46,7.37,8.84,12.01,16.43,13.05,11.28,2.06,22.09-.59,31.12-8.01l25.32,25.53c-8.51,9.01-18.86,14.21-30.47,16.87-24.71,4.49-51.14,1.93-70.8-14.23-13.3-10.93-20.3-26.44-20.63-43.68-.44-22.92,11.43-42.99,32.07-53.45,34.72-17.6,85.45-6.08,96.61,34.99-.16-26.21,20.38-38.03,44.18-41.81,13.19-1.78,26.1-1.16,39.26.85,8.54,1.47,16.41,3.72,24.45,7.58l-13.29,31.95c-12.73-6.7-26.53-9.4-40.69-8.21-5.11.43-9.39,2.73-8.89,5.86.16.99,1.72,2.87,2.78,3.05l17.38,2.98c9.73,1.67,19.38,2.79,28.34,6.67,10.89,4.73,17.68,14.23,18.51,25.99,1.66,23.47-16.98,37.58-38.92,41.54-21.06,3.8-42.3,1.68-62.73-4.42l-11.82-5.11ZM1094.5,561.03c-2.08-10.78-10.57-15.68-19.66-15.47-9.14.33-16.47,6.4-17.9,15.63l37.55-.16Z"></path>
                        <path d="M950.73,674.09c-24.03,3.3-54.7.1-75.32-13.28l16.11-32.9c13.25,9.11,32.14,13.47,48.1,10.41,12.66-2.71,17.76-12.38,17.11-25.02-15.67,15.91-43.32,14.68-61.15,4.29-18.13-10.57-27.56-28.97-27.34-49.66.23-22.13,12.16-41.36,32.64-50.34,12.65-5.55,26.82-6.5,40.24-2.72,7.4,2.09,12.91,6.35,17.94,12.77l.2-12.86h45.89s-.03,95.06-.03,95.06c0,8.76-1.18,16.82-3.62,24.95-7.02,23.41-27.04,36.04-50.77,39.3ZM936.41,587.63c9.02.37,16.8-4.14,19.52-11.62s1.28-16.69-5.51-21.62c-8.05-5.84-19.43-5.52-27.13.79-6.23,5.1-7.42,13.83-4.5,21.22,2.58,6.52,9.52,10.9,17.62,11.23Z"></path>
                        <path d="M615.17,622.53c-11.26,12.04-32.13,13.39-47.47,9.17-33.81-9.28-47.02-45.29-38.3-78.05,7.11-26.75,31.71-43.26,59.03-40.78,9.13.58,17.31,3.28,24.55,9.57l.04-49.33,48.32-.03v158.59s-45.88.01-45.88.01l-.29-9.17ZM612.63,582.34c1.66-6.27,1.64-12.72-.05-18.55-2.47-8.52-9.71-13.66-18.02-13.54-8.16.12-15.02,5.23-17.44,13.57-1.75,6.02-1.7,12.68.02,18.73,2.42,8.53,9.62,13.8,18.01,13.65,8.03-.14,15.2-5.25,17.48-13.86Z"></path>
                        <path d="M778.19,631.66l-48.3.05v-116.93s45.85,0,45.85,0l.21,12.22c10.61-10.72,23.42-14.31,37.76-14.36l-.04,42.81c-7.83-1.14-14.63-1.49-21.2.76-8.65,2.79-13.19,9.51-14.17,18.59l-.1,56.86Z"></path>
                        <polygon points="719.78 631.65 671.45 631.71 671.45 514.79 719.78 514.78 719.78 631.65"></polygon>
                        <polygon points="864.41 631.69 816.07 631.69 816.07 514.78 864.4 514.78 864.41 631.69"></polygon>
                        <path d="M1267.53,594.47c6.94-1.37,12.81,3.31,14.04,9.41,1.31,6.49-2.99,12.77-9.43,14.06-6.23,1.24-12.37-2.69-13.92-8.85s2.13-13.19,9.31-14.62Z"></path>
                        <g transform="translate(695.61 479.09)">
                          <g className="la-breathe">
                            <circle
                              className="la-kick la-dot--b"
                              r="28.03"
                            ></circle>
                          </g>
                        </g>
                        <g transform="translate(841.44 479.09)">
                          <g className="la-breathe">
                            <circle
                              className="la-kick la-dot--r"
                              r="28.03"
                            ></circle>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>

                  <g className="la-tag">
                    <path d="M742.84,710.69l16.22,22.83-14.29.04-9.05-13.64-9,13.62-22.28.09-3.57-8.57h-18.68s-3.34,8.52-3.34,8.52l-12.77-.05,19.4-43.98,12.3-.08,17.68,39.85,13.04-17.99-15.3-21.8,13.91-.11,8.85,12.76,8.71-12.7h13.45s-15.3,21.2-15.3,21.2ZM697.2,715.73l-5.65-13.91-5.62,13.97,11.27-.05Z"></path>
                    <polygon points="652.68 733.63 652.25 710.66 641.23 728.98 635.59 729.21 624.45 711.33 624.21 733.61 612.76 733.55 612.78 689.49 622.98 689.44 638.51 714.95 653.54 689.61 663.91 689.45 664.04 733.57 652.68 733.63"></polygon>
                    <path d="M554.12,733.63l-8.02-11.73h-6.86s0,11.7,0,11.7l-12.45-.03v-44.11s24.19.34,24.19.34c7.45.1,13.61,5.45,15.07,11.82,1.73,7.57-1.12,14.66-8.12,18.15l9.45,13.77-13.27.1ZM547.64,712.1c4.19-.1,6.41-3.21,6.29-6.59-.11-3.12-2.46-6.09-6.23-6.12l-8.47-.07v12.98s8.4-.21,8.4-.21Z"></path>
                    <polygon points="603.88 715.83 584.25 715.89 584.2 723.91 607.26 723.92 607.28 733.59 571.87 733.59 571.88 689.47 606.44 689.47 606.5 699.09 584.24 699.12 584.23 706.51 603.81 706.54 603.88 715.83"></polygon>
                    <path d="M1046.04,716.8c-1.48,9.35-9.11,16.32-18.43,16.46l-21.52.33v-40.95s21.01.25,21.01.25c12.6.15,20.96,11.14,18.94,23.91ZM1038.67,712.94c-.04-7.74-5.65-13.57-13.09-13.7l-11.89-.21v28.04s12.63-.19,12.63-.19c7.34-.11,12.39-6.34,12.35-13.95Z"></path>
                    <path d="M804.51,733.69l-8.44-12.09-10.85-.02v11.98s-7.59.05-7.59.05v-41s20.03.22,20.03.22c6.93.07,12.63,4.82,13.87,10.74,1.48,7.04-1.08,13.58-8.3,16.67l9.36,13.24-8.07.21ZM796.88,715.15c5.16-.14,7.7-4.67,7.36-8.81s-3.62-7.06-8.21-7.13l-10.83-.17.09,16.42,11.59-.31Z"></path>
                    <polygon points="846.3 715.89 826.48 715.93 826.51 727.16 849.61 727.17 849.54 733.59 818.88 733.59 818.89 692.63 848.69 692.6 848.71 699.05 826.47 699.05 826.49 709.59 846.25 709.59 846.3 715.89"></polygon>
                    <path d="M899.56,721.8l-.08,11.8-7.59-.05v-40.91s19.72.2,19.72.2c8.16.08,14.14,5.97,14.56,13.35.44,7.91-4.81,14.98-13.28,15.23l-13.33.4ZM910.87,715.14c5.02-.14,7.74-4.08,7.65-8.16s-3.1-7.64-7.73-7.73l-11.29-.23.03,16.44,11.34-.32Z"></path>
                    <path d="M956.92,724.14l-20.54-.12-4.04,9.53-7.85-.03,18.32-40.79,7.57-.05,18.42,40.81-7.9.18-3.97-9.53ZM954.19,717.97l-7.65-17.66-7.63,17.83,15.28-.17Z"></path>
                    <path d="M1078.93,724.05l-20.56.06-4.04,9.55-7.75-.17,18.36-40.79,7.44-.17,18.51,40.97-8,.07-3.97-9.51ZM1076.28,718.01l-7.63-17.76-7.66,17.9,15.28-.13Z"></path>
                    <path d="M880.02,731.73c-8.67,4.3-18.59,2.77-26.84-2.15l2.61-6.09c8.93,6.33,22.46,5.52,22.64-.79.04-1.39-1.69-3.95-3.2-4.38l-12.85-3.65c-4.97-1.41-8.32-5.15-8.39-9.98s2.58-9.08,7.38-10.94c7.4-2.86,15.26-2.06,22.7,1.7l-2.42,6.01c-8.85-4.96-20.38-3.65-20.16,2.5.07,1.99,1.94,3.9,3.99,4.48l12.28,3.46c4.49,1.26,7.68,4.64,8.01,8.94.3,3.95-1.33,8.7-5.77,10.9Z"></path>
                    <polygon points="1001.56 727.14 1001.54 733.59 972.53 733.6 972.54 692.82 980.13 692.57 980.14 727.09 1001.56 727.14"></polygon>
                    <path d="M1108.16,717.49c4.25-1.43,8.15,1.32,9.33,4.83,1.32,3.94-1.02,8.07-4.86,9.38s-7.64-.76-9.17-4.33c-1.58-3.68.18-8.37,4.7-9.89Z"></path>
                  </g>
                </svg>
              </div>

              <div className="hero-body">
                <p className="hero-sub" data-rv="" data-rv-d="80">
                  Tu propia oficina inmobiliaria.
                  <br />
                  <em>No una vacante de agente.</em>
                </p>

                <p className="lead" data-rv="" data-rv-d="140">
                  Formas tu equipo y construyes{" "}
                  <em className="acc">un activo tuyo</em>, con el respaldo de
                  una estructura que ya opera en más de 140 países.
                </p>

                <div className="hero-cta" data-rv="" data-rv-d="200">
                  <a className="btn btn-1" href="#reunion">
                    Solicita tu reunión
                    <svg
                      className="arrow"
                      width="20"
                      height="14"
                      viewBox="0 0 20 14"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M1 7h17M12 1l6 6-6 6"
                        stroke="currentColor"
                        strokeWidth="2.4"
                        strokeLinecap="square"
                      ></path>
                    </svg>
                  </a>
                  <a className="btn btn-2" href="#modelo">
                    Conoce el modelo
                  </a>
                </div>

                <p className="micro" data-rv="" data-rv-d="260">
                  Toma menos de un minuto · Sin compromiso
                </p>

                <div className="hero-badge" data-rv="" data-rv-d="340">
                  <b>+570</b>
                  <span>
                    agentes ya operan bajo la marca REMAX en República
                    Dominicana
                  </span>
                </div>
              </div>

              <div className="hero-scroll" aria-hidden="true">
                <span>Desliza</span>
                <i></i>
              </div>
            </div>
          </div>
        </section>

        <section className="sec sec-700" id="modelo">
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">01</span> El modelo
            </p>

            <div className="split">
              <div>
                <h2 className="d2" data-rv="">
                  Una franquicia no es
                  <br />
                  <em className="h-acc">una vacante de agente.</em>
                </h2>
              </div>
              <div>
                <p className="lead" data-rv="" data-rv-d="80">
                  El agente vende propiedades. El dueño de oficina dirige un
                  negocio: define la estructura, forma la cultura y multiplica
                  un equipo. Son dos caminos distintos, y esta página es sobre
                  el segundo.
                </p>

                <svg
                  className="trace"
                  viewBox="0 0 460 120"
                  role="img"
                  aria-label="Trayectoria: de la duda a la dirección"
                  data-rv-trace=""
                >
                  <path
                    className="path"
                    d="M18 96 C 110 96, 120 62, 200 60 C 285 58, 300 26, 442 22"
                    stroke="#FF1200"
                    strokeWidth="3.5"
                    fill="none"
                    strokeLinecap="round"
                  ></path>
                  <circle
                    className="pt pt-1"
                    cx="18"
                    cy="96"
                    r="8"
                    fill="#4A5165"
                  ></circle>
                  <circle
                    className="pt pt-2"
                    cx="200"
                    cy="60"
                    r="8"
                    fill="#0043FF"
                  ></circle>
                  <circle
                    className="pt pt-3"
                    cx="442"
                    cy="22"
                    r="10"
                    fill="#FF1200"
                  ></circle>
                  <text
                    x="18"
                    y="118"
                    fontFamily="Montserrat,sans-serif"
                    fontSize="12"
                    fontWeight="800"
                    fill="#4A5165"
                    letterSpacing="1.4"
                  >
                    DUDA
                  </text>
                  <text
                    x="176"
                    y="118"
                    fontFamily="Montserrat,sans-serif"
                    fontSize="12"
                    fontWeight="800"
                    fill="#4A5165"
                    letterSpacing="1.4"
                  >
                    DECISIÓN
                  </text>
                  <text
                    x="374"
                    y="118"
                    fontFamily="Montserrat,sans-serif"
                    fontSize="12"
                    fontWeight="800"
                    fill="#000E35"
                    letterSpacing="1.4"
                  >
                    DIRECCIÓN
                  </text>
                </svg>
              </div>
            </div>

            <div className="vs" data-rv="" data-rv-d="80">
              <div className="vs-col">
                <p className="vs-hd">
                  <span className="dot"></span> Agente inmobiliario
                </p>
                <ul>
                  <li>
                    Vende propiedades y <b>genera comisiones por operación</b>
                  </li>
                  <li>
                    Trabaja <b>dentro de una estructura</b> que otro creó
                  </li>
                  <li>Su resultado depende del tiempo que él mismo dedica</li>
                  <li>Se desarrolla dentro de una oficina existente</li>
                </ul>
              </div>
              <div className="vs-col own">
                <p className="vs-hd">
                  <span className="dot"></span> Dueño de oficina
                </p>
                <ul>
                  <li>
                    Dirige el negocio y{" "}
                    <b>construye un activo que le pertenece</b>
                  </li>
                  <li>
                    <b>Crea la estructura</b> y define la cultura de su oficina
                  </li>
                  <li>
                    Su resultado crece con el equipo que recluta y multiplica
                  </li>
                  <li>Opera un territorio con una marca ya establecida</li>
                </ul>
              </div>
            </div>

            <div
              className="split"
              style={
                {
                  marginTop: "clamp(48px,7vw,88px)",
                  alignItems: "center",
                } as React.CSSProperties
              }
            >
              <p className="quote" data-rv="">
                No necesitas vender cada propiedad.
                <br />
                <span>Necesitas liderar el negocio.</span>
              </p>
              <div
                className="ph"
                data-rv-ph=""
                style={{ aspectRatio: "4/5" } as React.CSSProperties}
              >
                <img
                  src="/franquicias/img/modelo.webp"
                  alt="Profesional de pie en su oficina, dirigiendo su propio negocio"
                  width="1200"
                  height="1500"
                  loading="lazy"
                  srcSet="/franquicias/img/modelo-480.webp 480w, /franquicias/img/modelo-800.webp 800w, /franquicias/img/modelo-1200.webp 1200w"
                  sizes="(max-width: 760px) 100vw, 50vw"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="sec light" id="respaldo">
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">02</span> El respaldo
            </p>

            <div className="split">
              <h2 className="d2" data-rv="">
                No compras un logo.
                <br />
                <em className="h-acc">
                  Accedes a una estructura{" "}
                  <span className="acc">que ya opera</span>.
                </em>
              </h2>
              <p className="lead" data-rv="" data-rv-d="80">
                Marca, tecnología, capacitación, red y acompañamiento regional.
                Todo eso existe antes de que abras y sigue funcionando después.
              </p>
            </div>

            <div className="stats" data-count="">
              <div className="st">
                <span className="n">
                  <span className="plus">+</span>
                  <span data-n="50">50</span>
                </span>
                <span className="lb">Años de trayectoria</span>
              </div>
              <div className="st">
                <span className="n">
                  <span className="plus">+</span>
                  <span data-n="140">140</span>
                </span>
                <span className="lb">Países con presencia</span>
              </div>
              <div className="st">
                <span className="n">
                  <span className="plus">+</span>
                  <span data-n="9000">9,000</span>
                </span>
                <span className="lb">Oficinas en la red</span>
              </div>
              <div className="st">
                <span className="n">
                  <span className="plus">+</span>
                  <span data-n="145000">145,000</span>
                </span>
                <span className="lb">Agentes en el mundo</span>
              </div>
              <div className="st wide">
                <svg
                  className="dr-map"
                  viewBox="180 0 1650 1060"
                  aria-hidden="true"
                  focusable="false"
                >
                  <defs>
                    <linearGradient
                      id="dr-grad"
                      gradientUnits="userSpaceOnUse"
                      x1="180"
                      y1="530"
                      x2="1830"
                      y2="530"
                    >
                      <stop offset="0%" stopColor="#ff1200"></stop>
                      <stop offset="50%" stopColor="#cc44ff"></stop>
                      <stop offset="100%" stopColor="#5b84ff"></stop>
                    </linearGradient>
                  </defs>
                  <path
                    className="map-fill"
                    d="M640.84,25.87c21.42,0,43.1,11.26,59.6,21.06c8.03,4.77,16.14,10.15,23.98,15.35 c28.75,19.08,58.48,38.81,96.97,38.81c13.07-0.09,25.8-2.23,38.18-6.44c4.46,1.59,14.95,8.7,24.59,18.55 c30.95,31.63,62.64,47.01,96.88,47.01c21.07,0,42.8-5.73,66.43-17.52c5.36-2.81,11.06-4.28,17.11-4.4 c16.51,0,28.61,13.72,30.11,34.16c1.98,26.98,6.67,51.01,13.92,71.42c18.25,51.35,45.44,74.26,88.16,74.26 c13.76,0,29.52-2.46,48.19-7.54c18.52-5.04,38.74-5.71,60.14-6.43c5.67-0.19,11.55-0.39,17.34-0.67c3.93-0.19,7.99-0.33,11.91-0.46 c18-0.61,36.53-1.24,55.11-7.07l8.09,5.29l12.65,8.27c-2.51,5.42-5.6,9.33-9.35,11.85c-4.86,3.28-11.68,4.81-21.44,4.81 c-7.03,0-14.62-0.77-22.67-1.57c-8.54-0.86-17.38-1.74-26.15-1.74c-3.09,0-5.94,0.1-8.73,0.32c-0.56,0.05-1.15,0.07-1.74,0.07 c-5.22,0-11.54-1.62-18.22-3.35c-5.57-1.54-11.2-2.77-16.91-3.69c-13.47-1.98-22.39-2.83-29.8-2.83c-9.39,0-23.01,1.21-32.94,11.7 c-12.95,13.67-12.79,35.78-11.14,65.52c0.06,1.04,0.2,2.06,0.44,3.06c0.24,1.01,0.57,1.98,0.98,2.94c0.41,0.95,0.91,1.85,1.49,2.71 c0.57,0.86,1.22,1.66,1.94,2.41c0.72,0.74,1.51,1.42,2.34,2.02c0.84,0.6,1.73,1.13,2.67,1.57c0.94,0.45,1.91,0.8,2.9,1.08 c1,0.27,2.02,0.45,3.05,0.54c2.41,0.21,5.14,0.65,8.04,1.1c5.62,1.03,11.29,1.6,17.01,1.73c3.12,0.02,6.23-0.25,9.31-0.8 c6.82-1.23,13.7-1.84,20.62-1.84c27.04,0,53.1,8.87,80.69,18.26c29.04,9.88,59.07,20.1,91.83,20.1c2.49,0,5.01-0.06,7.47-0.18 c1.97,0.52,3.9,1.17,5.79,1.95c4.84,1.85,10.34,3.93,16.61,3.93c3.53,0.03,6.91-0.67,10.15-2.09 c16.06-7.11,30.99-10.57,45.66-10.57c41.88,0,76.15,29.28,112.44,60.28c2.99,2.55,5.98,5.1,8.97,7.64 c36.11,30.61,71.66,60.26,109.55,86.57c7.71,5.35,12.27,10.2,13.17,14.02c0.84,3.56-0.96,9.08-5.36,16.41 c-5.65,9.4-10.61,19.2-15.41,28.68c-8.93,17.65-17.36,34.32-29.16,46.74c-3.19,3.35-17.49,4.76-27.94,5.78 c-5.77,0.57-12.07,1.18-18.53,2.14c-1.31-0.31-2.65-0.46-4-0.46c-7.28,0-12.81,3.82-16.45,11.33c-0.27,0.56-0.52,1.14-0.72,1.72 c-0.12,0.22-0.26,0.44-0.39,0.65c-8.57,13.68-17.4,27.54-25.96,40.99c-0.76-0.58-1.52-1.15-2.27-1.72 c-11.83-8.95-22.99-17.41-28.53-27.22c-19.32-34.31-45.69-49.61-85.48-49.62c-4.85,0-9.9,0.22-15.44,0.66 c-2.71,0.22-5.58,0.33-8.52,0.33c-14.16,0-28.84-2.46-44.37-5.06c-9.14-1.53-18.59-3.1-28.08-4.18c-3.63-0.41-7.4-1.01-11.38-1.65 c-8.06-1.29-16.4-2.61-25.1-2.61c-3.91-0.02-7.79,0.28-11.64,0.91c-30.83,5.08-63.6,10.05-95.51,10.05 c-33.89,0-63.93-5.7-91.84-17.42c-8.01-3.4-16.27-5.98-24.8-7.73c-8.52-1.74-17.14-2.63-25.83-2.66 c-46.06,0-88.29,24.62-115.84,67.56c-21.56,33.58-44.59,47.91-77.02,47.91c-5.53-0.02-11.03-0.39-16.51-1.1 c-4.85-0.59-9.72-0.89-14.61-0.88c-17.61,0-34.85,3.44-51.52,6.77l-3.08,0.61c-2.15,0.43-4.32,0.66-6.51,0.66 c-1.71,0.03-3.4-0.11-5.08-0.44c-1.68-0.32-3.31-0.81-4.89-1.47c-1.58-0.67-3.07-1.48-4.47-2.45s-2.7-2.08-3.88-3.32 c-5.21-5.48-8.4-13.64-8.98-22.97c-0.85-13.93-6.58-26.64-11.62-37.84c-2.07-4.61-4.03-8.96-5.59-13.18 c-0.4-1.09-0.91-2.13-1.53-3.12c-0.61-0.99-1.32-1.91-2.11-2.76c-0.8-0.85-1.68-1.61-2.62-2.28c-0.95-0.67-1.96-1.24-3.03-1.71 c-1.07-0.47-2.17-0.83-3.31-1.07c-1.14-0.25-2.29-0.38-3.45-0.4c-1.17-0.02-2.32,0.08-3.46,0.3c-1.15,0.22-2.26,0.55-3.34,0.98 c-4.36,1.78-8.76,3.44-13.42,5.2c-10.59,3.99-21.54,8.12-32.1,13.79c-11.65,6.27-23.14,13-34.24,19.51 c-17.89,10.49-34.86,20.44-52.62,28.7c-1.95-0.98-4.59-2.52-6.53-3.66c-6.11-3.57-13.05-7.62-20.67-9.46 c-7.92-2.06-15.97-3.18-24.15-3.34c-9.8,0-17.77,2.35-23.69,6.98c-13.4,10.49-18.8,38.49-10.32,53.51 c9.15,16.18,8.15,26.89,6.6,33.53c-2.23,9.59-8.3,20.28-19.66,34.66c-33.41,42.26-64.36,85.18-97.14,130.62 c-8.81,12.21-17.81,24.7-26.94,37.27c-1.14-1.9-2.28-3.86-3.44-5.84c-12.21-20.89-28.94-49.49-64.28-49.5 c-3.01,0.01-6.01,0.21-8.99,0.6c2.46-36.78-7.52-68.94-31.4-103.45c-11.96-17.29-11.93-48.66-11.9-76.33 c0-5.76,0.01-11.72-0.09-17.43c-0.08-4.57,5.65-13.23,10.26-20.2c3.38-4.92,6.48-10.01,9.33-15.25c0.41-0.79,0.76-1.61,1.05-2.45 s0.51-1.7,0.66-2.58c0.16-0.88,0.24-1.76,0.26-2.65c0.02-0.9-0.03-1.78-0.15-2.67c-0.12-0.88-0.31-1.75-0.56-2.6 c-0.26-0.85-0.57-1.69-0.95-2.49c-0.39-0.81-0.82-1.58-1.32-2.32c-0.5-0.74-1.06-1.43-1.67-2.09c-0.6-0.65-1.26-1.25-1.96-1.8 c-0.7-0.55-1.44-1.05-2.22-1.48c-0.78-0.44-1.58-0.82-2.42-1.13c-0.84-0.31-1.69-0.56-2.56-0.74c-0.88-0.18-1.76-0.3-2.65-0.34 s-1.78-0.02-2.67,0.07c-0.89,0.09-1.77,0.25-2.63,0.47c-0.86,0.22-1.7,0.52-2.52,0.87l-1.38,0.6l-87.54-105.04 c4.17,0.49,8.34,0.74,12.54,0.74c45.59,0,76.28-29.28,91.21-87.02c5.87-22.68,7.14-61.02-37.51-87.65 c8.77-5.76,17.11-12.06,25.04-18.91c32.15-28.49,51.56-45.69,51.5-68.02c-0.05-21.92-18.55-38.15-49.19-65.04 c-0.19-0.17-0.37-0.35-0.54-0.55c43.26-36.53,32.53-81.59,13.68-125.26c-8.17-18.93-8.81-42.92-9.37-64.09 c-0.19-7.25-0.38-14.2-0.83-20.79c10.39-14.8,21.35-25.4,33.39-32.32c5.76-3.29,11.84-5.76,18.27-7.41 c6.42-1.65,12.95-2.42,19.58-2.31c23.08,0,47.93,8.14,78.12,20.35c7.71,3.17,15.66,5.56,23.84,7.19 c8.18,1.63,16.44,2.46,24.78,2.49c28.99,0,57.94-9.6,91.07-30.22c4.89-3.17,10.13-5.58,15.72-7.24c5.59-1.66,11.3-2.49,17.12-2.51 M640.84,8.52c-7.45,0.02-14.74,1.08-21.9,3.18c-7.15,2.1-13.85,5.17-20.12,9.2c-26.31,16.37-53.38,27.6-81.9,27.6 c-7.22-0.02-14.38-0.74-21.46-2.16c-7.08-1.42-13.96-3.5-20.64-6.26c-28.96-11.72-57.48-21.62-84.64-21.62 c-32.07,0-62.26,13.81-89.06,54.74c2.83,26.8-1.3,65.37,12.09,96.4c19.97,46.29,26.58,83.62-21.62,114.39 c5.8,8.01,8.56,13.73,12.96,17.58c57.96,50.86,58.25,53.31-2.38,107.03c-14.04,12.44-30.65,21.98-48.94,34.89 c38.8,13.12,67.29,37.15,56.13,80.31c-11.08,42.83-32.66,74.01-74.4,74.01c-13.1,0-28.2-3.07-45.58-9.82 c0.42,5.14,0.84,10.27,1.26,15.41l114.31,137.16l13.31-5.77c-7.62,14.6-21.8,29.31-21.55,43.77c0.6,35.09-2.81,77.49,15.07,103.33 c25.69,37.11,34.75,71.1,24.65,118.01c11.77-5.38,21.61-7.68,30.03-7.68c37.93,0,46.46,46.72,67.81,67.33 c47.32-64.62,90.61-127.02,137.61-186.47c22.38-28.32,33.96-53.16,14.55-87.48c-4.26-7.52-0.65-26.18,5.91-31.31 c3.09-2.42,7.78-3.3,12.98-3.3c6.8,0.2,13.49,1.16,20.08,2.87c10.92,2.63,23.72,14.35,31.88,14.35c0.95,0.02,1.86-0.17,2.73-0.55 c31.74-14.23,60.97-33.94,91.75-50.48c13.88-7.46,29.2-12.22,43.86-18.21c5.67,15.34,15.21,30.45,16.18,46.08 c1.71,27.69,20,46.94,44.63,46.94c3.33-0.01,6.62-0.34,9.89-0.99c16.76-3.33,34.28-7.05,51.21-7.05c4.16-0.01,8.31,0.23,12.44,0.74 c6.2,0.8,12.43,1.21,18.68,1.23c39.86,0,67.62-18.49,91.64-55.9c24.51-38.18,61.91-59.57,101.22-59.57 c7.55,0.03,15.02,0.8,22.41,2.32c7.39,1.52,14.56,3.76,21.5,6.71c33.16,13.93,65.85,18.78,98.57,18.78 c32.6,0,65.23-4.82,98.33-10.28c2.92-0.47,5.86-0.69,8.82-0.68c11.31,0,23.1,2.85,34.54,4.15c24.8,2.8,49.85,9.34,74.4,9.34 c3.31,0,6.61-0.12,9.9-0.39c4.87-0.39,9.55-0.6,14.05-0.6c30.57,0,52.92,9.83,70.35,40.78c10.6,18.82,33.06,30.95,50.17,46.1 c12.16-19.14,24.4-38.22,36.43-57.44c0.82-1.32,1.56-2.67,2.22-4.07l-0.2,0.04c0.22-0.54,0.5-1.06,0.82-1.55 c-0.15,0.53-0.36,1.03-0.62,1.51c25.67-5.05,52.36-2.43,63.7-14.38c20.45-21.55,31.09-52.2,46.86-78.43 c13.67-22.75,10.25-37.6-12.79-53.6c-37.71-26.19-73.15-55.82-108.23-85.56c-40.98-34.73-80.57-72.04-132.64-72.04 c-16.22,0-33.65,3.61-52.7,12.06c-0.99,0.42-2.03,0.62-3.11,0.6c-6.37,0-15.03-5.89-22.31-5.89c-0.21,0-0.43,0-0.65,0.02 c-2.31,0.11-4.61,0.17-6.91,0.17c-59.8,0-112.7-38.35-172.53-38.35c-7.97-0.02-15.89,0.69-23.74,2.11 c-2.05,0.36-4.11,0.54-6.19,0.52c-7.81,0-15.95-2.1-23.53-2.77c-2.52-45.54,0.5-58.91,26.74-58.91c7.21,0,16.18,1.01,27.28,2.64 c12.62,1.85,25.31,7.23,37.65,7.23c1.04,0,2.07-0.04,3.11-0.11c2.41-0.19,4.86-0.28,7.36-0.27c15.82,0,33.03,3.31,48.83,3.31 c22.94,0,42.95-6.98,51.52-41.2l-39.2-25.62c-22.49,9.21-46.37,8.28-70.14,9.45c-27.18,1.33-55.32,0.66-81.18,7.68 c-16.6,4.52-31.02,6.93-43.63,6.93c-34.95,0-56.11-18.58-71.79-62.7c-7.53-21.2-11.31-44.35-12.96-66.89 c-2.23-30.44-22.34-50.24-47.43-50.24c-4.33,0.06-8.6,0.61-12.8,1.66c-4.2,1.05-8.22,2.58-12.07,4.57 c-20.99,10.47-40.34,15.69-58.68,15.69c-29.98,0-57.25-13.97-84.45-41.78c-9.87-10.09-27.1-24.04-37.51-24.04 c-1.03-0.02-2.03,0.15-3.01,0.47c-11.2,4.06-22.76,6.14-34.67,6.22c-43.15,0-75.46-29.96-112.08-51.72 c-21.17-12.58-44.34-23.49-68.47-23.49V8.52z"
                  ></path>
                  <path
                    className="path"
                    d="M640.84,25.87c21.42,0,43.1,11.26,59.6,21.06c8.03,4.77,16.14,10.15,23.98,15.35 c28.75,19.08,58.48,38.81,96.97,38.81c13.07-0.09,25.8-2.23,38.18-6.44c4.46,1.59,14.95,8.7,24.59,18.55 c30.95,31.63,62.64,47.01,96.88,47.01c21.07,0,42.8-5.73,66.43-17.52c5.36-2.81,11.06-4.28,17.11-4.4 c16.51,0,28.61,13.72,30.11,34.16c1.98,26.98,6.67,51.01,13.92,71.42c18.25,51.35,45.44,74.26,88.16,74.26 c13.76,0,29.52-2.46,48.19-7.54c18.52-5.04,38.74-5.71,60.14-6.43c5.67-0.19,11.55-0.39,17.34-0.67c3.93-0.19,7.99-0.33,11.91-0.46 c18-0.61,36.53-1.24,55.11-7.07l8.09,5.29l12.65,8.27c-2.51,5.42-5.6,9.33-9.35,11.85c-4.86,3.28-11.68,4.81-21.44,4.81 c-7.03,0-14.62-0.77-22.67-1.57c-8.54-0.86-17.38-1.74-26.15-1.74c-3.09,0-5.94,0.1-8.73,0.32c-0.56,0.05-1.15,0.07-1.74,0.07 c-5.22,0-11.54-1.62-18.22-3.35c-5.57-1.54-11.2-2.77-16.91-3.69c-13.47-1.98-22.39-2.83-29.8-2.83c-9.39,0-23.01,1.21-32.94,11.7 c-12.95,13.67-12.79,35.78-11.14,65.52c0.06,1.04,0.2,2.06,0.44,3.06c0.24,1.01,0.57,1.98,0.98,2.94c0.41,0.95,0.91,1.85,1.49,2.71 c0.57,0.86,1.22,1.66,1.94,2.41c0.72,0.74,1.51,1.42,2.34,2.02c0.84,0.6,1.73,1.13,2.67,1.57c0.94,0.45,1.91,0.8,2.9,1.08 c1,0.27,2.02,0.45,3.05,0.54c2.41,0.21,5.14,0.65,8.04,1.1c5.62,1.03,11.29,1.6,17.01,1.73c3.12,0.02,6.23-0.25,9.31-0.8 c6.82-1.23,13.7-1.84,20.62-1.84c27.04,0,53.1,8.87,80.69,18.26c29.04,9.88,59.07,20.1,91.83,20.1c2.49,0,5.01-0.06,7.47-0.18 c1.97,0.52,3.9,1.17,5.79,1.95c4.84,1.85,10.34,3.93,16.61,3.93c3.53,0.03,6.91-0.67,10.15-2.09 c16.06-7.11,30.99-10.57,45.66-10.57c41.88,0,76.15,29.28,112.44,60.28c2.99,2.55,5.98,5.1,8.97,7.64 c36.11,30.61,71.66,60.26,109.55,86.57c7.71,5.35,12.27,10.2,13.17,14.02c0.84,3.56-0.96,9.08-5.36,16.41 c-5.65,9.4-10.61,19.2-15.41,28.68c-8.93,17.65-17.36,34.32-29.16,46.74c-3.19,3.35-17.49,4.76-27.94,5.78 c-5.77,0.57-12.07,1.18-18.53,2.14c-1.31-0.31-2.65-0.46-4-0.46c-7.28,0-12.81,3.82-16.45,11.33c-0.27,0.56-0.52,1.14-0.72,1.72 c-0.12,0.22-0.26,0.44-0.39,0.65c-8.57,13.68-17.4,27.54-25.96,40.99c-0.76-0.58-1.52-1.15-2.27-1.72 c-11.83-8.95-22.99-17.41-28.53-27.22c-19.32-34.31-45.69-49.61-85.48-49.62c-4.85,0-9.9,0.22-15.44,0.66 c-2.71,0.22-5.58,0.33-8.52,0.33c-14.16,0-28.84-2.46-44.37-5.06c-9.14-1.53-18.59-3.1-28.08-4.18c-3.63-0.41-7.4-1.01-11.38-1.65 c-8.06-1.29-16.4-2.61-25.1-2.61c-3.91-0.02-7.79,0.28-11.64,0.91c-30.83,5.08-63.6,10.05-95.51,10.05 c-33.89,0-63.93-5.7-91.84-17.42c-8.01-3.4-16.27-5.98-24.8-7.73c-8.52-1.74-17.14-2.63-25.83-2.66 c-46.06,0-88.29,24.62-115.84,67.56c-21.56,33.58-44.59,47.91-77.02,47.91c-5.53-0.02-11.03-0.39-16.51-1.1 c-4.85-0.59-9.72-0.89-14.61-0.88c-17.61,0-34.85,3.44-51.52,6.77l-3.08,0.61c-2.15,0.43-4.32,0.66-6.51,0.66 c-1.71,0.03-3.4-0.11-5.08-0.44c-1.68-0.32-3.31-0.81-4.89-1.47c-1.58-0.67-3.07-1.48-4.47-2.45s-2.7-2.08-3.88-3.32 c-5.21-5.48-8.4-13.64-8.98-22.97c-0.85-13.93-6.58-26.64-11.62-37.84c-2.07-4.61-4.03-8.96-5.59-13.18 c-0.4-1.09-0.91-2.13-1.53-3.12c-0.61-0.99-1.32-1.91-2.11-2.76c-0.8-0.85-1.68-1.61-2.62-2.28c-0.95-0.67-1.96-1.24-3.03-1.71 c-1.07-0.47-2.17-0.83-3.31-1.07c-1.14-0.25-2.29-0.38-3.45-0.4c-1.17-0.02-2.32,0.08-3.46,0.3c-1.15,0.22-2.26,0.55-3.34,0.98 c-4.36,1.78-8.76,3.44-13.42,5.2c-10.59,3.99-21.54,8.12-32.1,13.79c-11.65,6.27-23.14,13-34.24,19.51 c-17.89,10.49-34.86,20.44-52.62,28.7c-1.95-0.98-4.59-2.52-6.53-3.66c-6.11-3.57-13.05-7.62-20.67-9.46 c-7.92-2.06-15.97-3.18-24.15-3.34c-9.8,0-17.77,2.35-23.69,6.98c-13.4,10.49-18.8,38.49-10.32,53.51 c9.15,16.18,8.15,26.89,6.6,33.53c-2.23,9.59-8.3,20.28-19.66,34.66c-33.41,42.26-64.36,85.18-97.14,130.62 c-8.81,12.21-17.81,24.7-26.94,37.27c-1.14-1.9-2.28-3.86-3.44-5.84c-12.21-20.89-28.94-49.49-64.28-49.5 c-3.01,0.01-6.01,0.21-8.99,0.6c2.46-36.78-7.52-68.94-31.4-103.45c-11.96-17.29-11.93-48.66-11.9-76.33 c0-5.76,0.01-11.72-0.09-17.43c-0.08-4.57,5.65-13.23,10.26-20.2c3.38-4.92,6.48-10.01,9.33-15.25c0.41-0.79,0.76-1.61,1.05-2.45 s0.51-1.7,0.66-2.58c0.16-0.88,0.24-1.76,0.26-2.65c0.02-0.9-0.03-1.78-0.15-2.67c-0.12-0.88-0.31-1.75-0.56-2.6 c-0.26-0.85-0.57-1.69-0.95-2.49c-0.39-0.81-0.82-1.58-1.32-2.32c-0.5-0.74-1.06-1.43-1.67-2.09c-0.6-0.65-1.26-1.25-1.96-1.8 c-0.7-0.55-1.44-1.05-2.22-1.48c-0.78-0.44-1.58-0.82-2.42-1.13c-0.84-0.31-1.69-0.56-2.56-0.74c-0.88-0.18-1.76-0.3-2.65-0.34 s-1.78-0.02-2.67,0.07c-0.89,0.09-1.77,0.25-2.63,0.47c-0.86,0.22-1.7,0.52-2.52,0.87l-1.38,0.6l-87.54-105.04 c4.17,0.49,8.34,0.74,12.54,0.74c45.59,0,76.28-29.28,91.21-87.02c5.87-22.68,7.14-61.02-37.51-87.65 c8.77-5.76,17.11-12.06,25.04-18.91c32.15-28.49,51.56-45.69,51.5-68.02c-0.05-21.92-18.55-38.15-49.19-65.04 c-0.19-0.17-0.37-0.35-0.54-0.55c43.26-36.53,32.53-81.59,13.68-125.26c-8.17-18.93-8.81-42.92-9.37-64.09 c-0.19-7.25-0.38-14.2-0.83-20.79c10.39-14.8,21.35-25.4,33.39-32.32c5.76-3.29,11.84-5.76,18.27-7.41 c6.42-1.65,12.95-2.42,19.58-2.31c23.08,0,47.93,8.14,78.12,20.35c7.71,3.17,15.66,5.56,23.84,7.19 c8.18,1.63,16.44,2.46,24.78,2.49c28.99,0,57.94-9.6,91.07-30.22c4.89-3.17,10.13-5.58,15.72-7.24c5.59-1.66,11.3-2.49,17.12-2.51 M640.84,8.52c-7.45,0.02-14.74,1.08-21.9,3.18c-7.15,2.1-13.85,5.17-20.12,9.2c-26.31,16.37-53.38,27.6-81.9,27.6 c-7.22-0.02-14.38-0.74-21.46-2.16c-7.08-1.42-13.96-3.5-20.64-6.26c-28.96-11.72-57.48-21.62-84.64-21.62 c-32.07,0-62.26,13.81-89.06,54.74c2.83,26.8-1.3,65.37,12.09,96.4c19.97,46.29,26.58,83.62-21.62,114.39 c5.8,8.01,8.56,13.73,12.96,17.58c57.96,50.86,58.25,53.31-2.38,107.03c-14.04,12.44-30.65,21.98-48.94,34.89 c38.8,13.12,67.29,37.15,56.13,80.31c-11.08,42.83-32.66,74.01-74.4,74.01c-13.1,0-28.2-3.07-45.58-9.82 c0.42,5.14,0.84,10.27,1.26,15.41l114.31,137.16l13.31-5.77c-7.62,14.6-21.8,29.31-21.55,43.77c0.6,35.09-2.81,77.49,15.07,103.33 c25.69,37.11,34.75,71.1,24.65,118.01c11.77-5.38,21.61-7.68,30.03-7.68c37.93,0,46.46,46.72,67.81,67.33 c47.32-64.62,90.61-127.02,137.61-186.47c22.38-28.32,33.96-53.16,14.55-87.48c-4.26-7.52-0.65-26.18,5.91-31.31 c3.09-2.42,7.78-3.3,12.98-3.3c6.8,0.2,13.49,1.16,20.08,2.87c10.92,2.63,23.72,14.35,31.88,14.35c0.95,0.02,1.86-0.17,2.73-0.55 c31.74-14.23,60.97-33.94,91.75-50.48c13.88-7.46,29.2-12.22,43.86-18.21c5.67,15.34,15.21,30.45,16.18,46.08 c1.71,27.69,20,46.94,44.63,46.94c3.33-0.01,6.62-0.34,9.89-0.99c16.76-3.33,34.28-7.05,51.21-7.05c4.16-0.01,8.31,0.23,12.44,0.74 c6.2,0.8,12.43,1.21,18.68,1.23c39.86,0,67.62-18.49,91.64-55.9c24.51-38.18,61.91-59.57,101.22-59.57 c7.55,0.03,15.02,0.8,22.41,2.32c7.39,1.52,14.56,3.76,21.5,6.71c33.16,13.93,65.85,18.78,98.57,18.78 c32.6,0,65.23-4.82,98.33-10.28c2.92-0.47,5.86-0.69,8.82-0.68c11.31,0,23.1,2.85,34.54,4.15c24.8,2.8,49.85,9.34,74.4,9.34 c3.31,0,6.61-0.12,9.9-0.39c4.87-0.39,9.55-0.6,14.05-0.6c30.57,0,52.92,9.83,70.35,40.78c10.6,18.82,33.06,30.95,50.17,46.1 c12.16-19.14,24.4-38.22,36.43-57.44c0.82-1.32,1.56-2.67,2.22-4.07l-0.2,0.04c0.22-0.54,0.5-1.06,0.82-1.55 c-0.15,0.53-0.36,1.03-0.62,1.51c25.67-5.05,52.36-2.43,63.7-14.38c20.45-21.55,31.09-52.2,46.86-78.43 c13.67-22.75,10.25-37.6-12.79-53.6c-37.71-26.19-73.15-55.82-108.23-85.56c-40.98-34.73-80.57-72.04-132.64-72.04 c-16.22,0-33.65,3.61-52.7,12.06c-0.99,0.42-2.03,0.62-3.11,0.6c-6.37,0-15.03-5.89-22.31-5.89c-0.21,0-0.43,0-0.65,0.02 c-2.31,0.11-4.61,0.17-6.91,0.17c-59.8,0-112.7-38.35-172.53-38.35c-7.97-0.02-15.89,0.69-23.74,2.11 c-2.05,0.36-4.11,0.54-6.19,0.52c-7.81,0-15.95-2.1-23.53-2.77c-2.52-45.54,0.5-58.91,26.74-58.91c7.21,0,16.18,1.01,27.28,2.64 c12.62,1.85,25.31,7.23,37.65,7.23c1.04,0,2.07-0.04,3.11-0.11c2.41-0.19,4.86-0.28,7.36-0.27c15.82,0,33.03,3.31,48.83,3.31 c22.94,0,42.95-6.98,51.52-41.2l-39.2-25.62c-22.49,9.21-46.37,8.28-70.14,9.45c-27.18,1.33-55.32,0.66-81.18,7.68 c-16.6,4.52-31.02,6.93-43.63,6.93c-34.95,0-56.11-18.58-71.79-62.7c-7.53-21.2-11.31-44.35-12.96-66.89 c-2.23-30.44-22.34-50.24-47.43-50.24c-4.33,0.06-8.6,0.61-12.8,1.66c-4.2,1.05-8.22,2.58-12.07,4.57 c-20.99,10.47-40.34,15.69-58.68,15.69c-29.98,0-57.25-13.97-84.45-41.78c-9.87-10.09-27.1-24.04-37.51-24.04 c-1.03-0.02-2.03,0.15-3.01,0.47c-11.2,4.06-22.76,6.14-34.67,6.22c-43.15,0-75.46-29.96-112.08-51.72 c-21.17-12.58-44.34-23.49-68.47-23.49V8.52z"
                  ></path>
                </svg>
                <div className="wide-data">
                  <span className="n">
                    <span className="plus">+</span>
                    <span data-n="570">570</span>
                  </span>
                  <span className="lb">Agentes en República Dominicana</span>
                </div>
              </div>
            </div>

            <div className="closer">
              <svg
                viewBox="519 345 876 392"
                aria-label="Tú diriges. REMAX respalda."
                role="img"
                data-rv-clip=""
                style={
                  {
                    width: "min(380px,72vw)",
                    height: "auto",
                    display: "block",
                  } as React.CSSProperties
                }
                fill="currentColor"
              >
                <g>
                  <polygon points="674.99 419.24 652.04 419.36 669.55 359.99 692.43 359.99 674.99 419.24"></polygon>
                  <g>
                    <path d="M622.1,361.91l10.33-.09-.28,34.93c-.11,14.3-11.38,22.62-24.64,22.62-13.34,0-24.55-8.28-24.65-22.62l-.25-34.92h10.48s.32,35.27.32,35.27c.07,8.13,6.55,12.93,14.13,12.99,7.1.06,14.07-4.61,14.16-12.49l.4-35.68Z"></path>
                    <polygon points="556.21 418.27 545.58 418.4 545.6 370.71 526.97 370.61 526.79 361.71 574.88 361.71 574.68 370.64 556.16 370.67 556.21 418.27"></polygon>
                    <path d="M610.48,356.31c-1.7,1.36-6.98.88-9.15.4l10.59-10.96,11.05.59-12.49,9.97Z"></path>
                  </g>
                </g>
                <path d="M742.84,710.69l16.22,22.83-14.29.04-9.05-13.64-9,13.62-22.28.09-3.57-8.57h-18.68s-3.34,8.52-3.34,8.52l-12.77-.05,19.4-43.98,12.3-.08,17.68,39.85,13.04-17.99-15.3-21.8,13.91-.11,8.85,12.76,8.71-12.7h13.45s-15.3,21.2-15.3,21.2ZM697.2,715.73l-5.65-13.91-5.62,13.97,11.27-.05Z"></path>
                <polygon points="652.68 733.63 652.25 710.66 641.23 728.98 635.59 729.21 624.45 711.33 624.21 733.61 612.76 733.55 612.78 689.49 622.98 689.44 638.51 714.95 653.54 689.61 663.91 689.45 664.04 733.57 652.68 733.63"></polygon>
                <path d="M554.12,733.63l-8.02-11.73h-6.86s0,11.7,0,11.7l-12.45-.03v-44.11s24.19.34,24.19.34c7.45.1,13.61,5.45,15.07,11.82,1.73,7.57-1.12,14.66-8.12,18.15l9.45,13.77-13.27.1ZM547.64,712.1c4.19-.1,6.41-3.21,6.29-6.59-.11-3.12-2.46-6.09-6.23-6.12l-8.47-.07v12.98s8.4-.21,8.4-.21Z"></path>
                <polygon points="603.88 715.83 584.25 715.89 584.2 723.91 607.26 723.92 607.28 733.59 571.87 733.59 571.88 689.47 606.44 689.47 606.5 699.09 584.24 699.12 584.23 706.51 603.81 706.54 603.88 715.83"></polygon>
                <path d="M1046.04,716.8c-1.48,9.35-9.11,16.32-18.43,16.46l-21.52.33v-40.95s21.01.25,21.01.25c12.6.15,20.96,11.14,18.94,23.91ZM1038.67,712.94c-.04-7.74-5.65-13.57-13.09-13.7l-11.89-.21v28.04s12.63-.19,12.63-.19c7.34-.11,12.39-6.34,12.35-13.95Z"></path>
                <path d="M804.51,733.69l-8.44-12.09-10.85-.02v11.98s-7.59.05-7.59.05v-41s20.03.22,20.03.22c6.93.07,12.63,4.82,13.87,10.74,1.48,7.04-1.08,13.58-8.3,16.67l9.36,13.24-8.07.21ZM796.88,715.15c5.16-.14,7.7-4.67,7.36-8.81s-3.62-7.06-8.21-7.13l-10.83-.17.09,16.42,11.59-.31Z"></path>
                <polygon points="846.3 715.89 826.48 715.93 826.51 727.16 849.61 727.17 849.54 733.59 818.88 733.59 818.89 692.63 848.69 692.6 848.71 699.05 826.47 699.05 826.49 709.59 846.25 709.59 846.3 715.89"></polygon>
                <path d="M899.56,721.8l-.08,11.8-7.59-.05v-40.91s19.72.2,19.72.2c8.16.08,14.14,5.97,14.56,13.35.44,7.91-4.81,14.98-13.28,15.23l-13.33.4ZM910.87,715.14c5.02-.14,7.74-4.08,7.65-8.16s-3.1-7.64-7.73-7.73l-11.29-.23.03,16.44,11.34-.32Z"></path>
                <path d="M956.92,724.14l-20.54-.12-4.04,9.53-7.85-.03,18.32-40.79,7.57-.05,18.42,40.81-7.9.18-3.97-9.53ZM954.19,717.97l-7.65-17.66-7.63,17.83,15.28-.17Z"></path>
                <path d="M1078.93,724.05l-20.56.06-4.04,9.55-7.75-.17,18.36-40.79,7.44-.17,18.51,40.97-8,.07-3.97-9.51ZM1076.28,718.01l-7.63-17.76-7.66,17.9,15.28-.13Z"></path>
                <path d="M880.02,731.73c-8.67,4.3-18.59,2.77-26.84-2.15l2.61-6.09c8.93,6.33,22.46,5.52,22.64-.79.04-1.39-1.69-3.95-3.2-4.38l-12.85-3.65c-4.97-1.41-8.32-5.15-8.39-9.98s2.58-9.08,7.38-10.94c7.4-2.86,15.26-2.06,22.7,1.7l-2.42,6.01c-8.85-4.96-20.38-3.65-20.16,2.5.07,1.99,1.94,3.9,3.99,4.48l12.28,3.46c4.49,1.26,7.68,4.64,8.01,8.94.3,3.95-1.33,8.7-5.77,10.9Z"></path>
                <polygon points="1001.56 727.14 1001.54 733.59 972.53 733.6 972.54 692.82 980.13 692.57 980.14 727.09 1001.56 727.14"></polygon>
                <path d="M1108.16,717.49c4.25-1.43,8.15,1.32,9.33,4.83,1.32,3.94-1.02,8.07-4.86,9.38s-7.64-.76-9.17-4.33c-1.58-3.68.18-8.37,4.7-9.89Z"></path>
                <path d="M1136.27,622.41l13.26-31.94c14.56,7.98,31.1,11.41,47.85,10.12,4.88-.38,8.7-2.98,7.93-5.87-.26-.97-1.86-2.71-2.91-2.89l-14.79-2.55c-18.73-3.24-39.47-3.13-48.02-24.67l-.48,19.83h-81.05c2.46,7.37,8.84,12.01,16.43,13.05,11.28,2.06,22.09-.59,31.12-8.01l25.32,25.53c-8.51,9.01-18.86,14.21-30.47,16.87-24.71,4.49-51.14,1.93-70.8-14.23-13.3-10.93-20.3-26.44-20.63-43.68-.44-22.92,11.43-42.99,32.07-53.45,34.72-17.6,85.45-6.08,96.61,34.99-.16-26.21,20.38-38.03,44.18-41.81,13.19-1.78,26.1-1.16,39.26.85,8.54,1.47,16.41,3.72,24.45,7.58l-13.29,31.95c-12.73-6.7-26.53-9.4-40.69-8.21-5.11.43-9.39,2.73-8.89,5.86.16.99,1.72,2.87,2.78,3.05l17.38,2.98c9.73,1.67,19.38,2.79,28.34,6.67,10.89,4.73,17.68,14.23,18.51,25.99,1.66,23.47-16.98,37.58-38.92,41.54-21.06,3.8-42.3,1.68-62.73-4.42l-11.82-5.11ZM1094.5,561.03c-2.08-10.78-10.57-15.68-19.66-15.47-9.14.33-16.47,6.4-17.9,15.63l37.55-.16Z"></path>
                <path d="M950.73,674.09c-24.03,3.3-54.7.1-75.32-13.28l16.11-32.9c13.25,9.11,32.14,13.47,48.1,10.41,12.66-2.71,17.76-12.38,17.11-25.02-15.67,15.91-43.32,14.68-61.15,4.29-18.13-10.57-27.56-28.97-27.34-49.66.23-22.13,12.16-41.36,32.64-50.34,12.65-5.55,26.82-6.5,40.24-2.72,7.4,2.09,12.91,6.35,17.94,12.77l.2-12.86h45.89s-.03,95.06-.03,95.06c0,8.76-1.18,16.82-3.62,24.95-7.02,23.41-27.04,36.04-50.77,39.3ZM936.41,587.63c9.02.37,16.8-4.14,19.52-11.62s1.28-16.69-5.51-21.62c-8.05-5.84-19.43-5.52-27.13.79-6.23,5.1-7.42,13.83-4.5,21.22,2.58,6.52,9.52,10.9,17.62,11.23Z"></path>
                <path d="M615.17,622.53c-11.26,12.04-32.13,13.39-47.47,9.17-33.81-9.28-47.02-45.29-38.3-78.05,7.11-26.75,31.71-43.26,59.03-40.78,9.13.58,17.31,3.28,24.55,9.57l.04-49.33,48.32-.03v158.59s-45.88.01-45.88.01l-.29-9.17ZM612.63,582.34c1.66-6.27,1.64-12.72-.05-18.55-2.47-8.52-9.71-13.66-18.02-13.54-8.16.12-15.02,5.23-17.44,13.57-1.75,6.02-1.7,12.68.02,18.73,2.42,8.53,9.62,13.8,18.01,13.65,8.03-.14,15.2-5.25,17.48-13.86Z"></path>
                <path d="M778.19,631.66l-48.3.05v-116.93s45.85,0,45.85,0l.21,12.22c10.61-10.72,23.42-14.31,37.76-14.36l-.04,42.81c-7.83-1.14-14.63-1.49-21.2.76-8.65,2.79-13.19,9.51-14.17,18.59l-.1,56.86Z"></path>
                <polygon points="719.78 631.65 671.45 631.71 671.45 514.79 719.78 514.78 719.78 631.65"></polygon>
                <polygon points="864.41 631.69 816.07 631.69 816.07 514.78 864.4 514.78 864.41 631.69"></polygon>
                <path d="M1267.53,594.47c6.94-1.37,12.81,3.31,14.04,9.41,1.31,6.49-2.99,12.77-9.43,14.06-6.23,1.24-12.37-2.69-13.92-8.85s2.13-13.19,9.31-14.62Z"></path>
                <circle
                  cx="695.61"
                  cy="479.09"
                  r="28.03"
                  fill="#0247fe"
                ></circle>
                <circle
                  cx="841.44"
                  cy="479.09"
                  r="28.03"
                  fill="#fd2107"
                ></circle>
              </svg>
              <p
                className="lead"
                data-rv=""
                data-rv-d="120"
                style={{ maxWidth: "32ch", margin: "0" } as React.CSSProperties}
              >
                Tú tomas las decisiones de tu negocio. La red sostiene el
                sistema que las hace posibles.
              </p>
            </div>
          </div>
        </section>

        <section className="sec sec-800" id="perfil">
          <div className="glow" aria-hidden="true"></div>
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">03</span> El perfil
            </p>

            <div className="split">
              <h2 className="d2" data-rv="">
                No necesitas ser
                <br />
                <em className="h-acc">agente inmobiliario.</em>
              </h2>
              <div>
                <p className="lead" data-rv="" data-rv-d="80">
                  Necesitas visión, gestión y liderazgo. Si sabes construir
                  relaciones y tomar decisiones de negocio, ya tienes lo que
                  este modelo exige. Lo demás se aprende dentro de la
                  estructura.
                </p>
                <p
                  className="micro"
                  data-rv=""
                  data-rv-d="140"
                  style={{ marginTop: "var(--s4)" } as React.CSSProperties}
                >
                  El perfil ideal es gestor y líder, no vendedor de campo.
                </p>
              </div>
            </div>

            <div className="prof">
              <div className="p">
                <span className="ix">01</span>
                <h3>Empresarios y dueños de negocio</h3>
                <p>
                  Ya saben lo que cuesta sostener una operación y quieren
                  diversificar con una marca probada.
                </p>
              </div>
              <div className="p">
                <span className="ix">02</span>
                <h3>Profesionales liberales</h3>
                <p>
                  Abogados, contadores y consultores con práctica propia y una
                  red de relaciones construida.
                </p>
              </div>
              <div className="p">
                <span className="ix">03</span>
                <h3>Ejecutivos y gerentes</h3>
                <p>
                  Con experiencia dirigiendo equipos y resultados, listos para
                  hacerlo por cuenta propia.
                </p>
              </div>
              <div className="p">
                <span className="ix">04</span>
                <h3>Banca, seguros y servicios financieros</h3>
                <p>
                  Entienden de confianza, cartera y decisiones patrimoniales. Es
                  el mismo músculo.
                </p>
              </div>
              <div className="p">
                <span className="ix">05</span>
                <h3>Comercio y sector productivo</h3>
                <p>
                  Gestionan inventario, personal y clientes todos los días.
                  Dirigir una oficina no es distinto.
                </p>
              </div>
              <div className="p">
                <span className="ix">06</span>
                <h3>Sector inmobiliario</h3>
                <p>
                  Quienes ya conocen el mercado y quieren pasar de operar dentro
                  de una oficina a dirigir la suya.
                </p>
              </div>
            </div>

            <div
              className="split"
              style={
                {
                  marginTop: "clamp(48px,7vw,88px)",
                  alignItems: "center",
                } as React.CSSProperties
              }
            >
              <div
                className="ph"
                data-rv-ph=""
                style={{ aspectRatio: "4/5" } as React.CSSProperties}
              >
                <img
                  src="/franquicias/img/perfil.webp"
                  alt="Profesionales dominicanos conversando sobre un proyecto de negocio"
                  width="1200"
                  height="1500"
                  loading="lazy"
                  srcSet="/franquicias/img/perfil-480.webp 480w, /franquicias/img/perfil-800.webp 800w, /franquicias/img/perfil-1200.webp 1200w"
                  sizes="(max-width: 760px) 100vw, 50vw"
                  decoding="async"
                />
              </div>
              <p className="d3 quote-pull" data-rv="">
                La experiencia puede venir de otro sector.
                <br />
                Lo que importa es saber relacionarte y gestionar.
              </p>
            </div>

            <div className="cta-band" data-rv="">
              <div>
                <h3>¿Te reconoces en alguno de estos perfiles?</h3>
                <p>
                  Agenda una reunión de presentación y evalúalo con datos, no
                  con suposiciones.
                </p>
              </div>
              <a className="btn btn-1" href="#reunion">
                Solicita tu reunión
                <svg
                  className="arrow"
                  width="20"
                  height="14"
                  viewBox="0 0 20 14"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M1 7h17M12 1l6 6-6 6"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="square"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </section>

        <section className="sec sec-700" id="incluye">
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">04</span> Qué recibes
            </p>

            <div className="split">
              <h2 className="d2" data-rv="">
                Emprender no significa
                <br />
                <em className="h-acc">empezar solo.</em>
              </h2>
              <p className="lead" data-rv="" data-rv-d="80">
                La idea es tuya. El camino no tienes que improvisarlo. Esto es
                lo que ya está montado el día que abres tu oficina.
              </p>
            </div>

            <div
              className="split"
              style={
                {
                  marginTop: "var(--s7)",
                  alignItems: "start",
                } as React.CSSProperties
              }
            >
              <ol
                className="incl"
                data-rv=""
                style={{ marginTop: "0" } as React.CSSProperties}
              >
                <li>
                  <span className="ix">01</span>
                  <div>
                    <h3>Una marca reconocida</h3>
                    <p>
                      Entras al mercado con un nombre que el cliente ya
                      identifica, en lugar de construir reputación desde cero.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="ix">02</span>
                  <div>
                    <h3>Tecnología y CRM desde el día uno</h3>
                    <p>
                      Las herramientas de gestión de cartera, clientes y equipo
                      están operativas antes de tu primera venta.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="ix">03</span>
                  <div>
                    <h3>Capacitación estructurada</h3>
                    <p>
                      Formación para ti como dueño y para los agentes que vayas
                      incorporando, con contenido y calendario definidos.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="ix">04</span>
                  <div>
                    <h3>Red global y regional</h3>
                    <p>
                      Referidos, buenas prácticas y contacto con oficinas que ya
                      resolvieron los problemas que tú vas a enfrentar.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="ix">05</span>
                  <div>
                    <h3>Acompañamiento continuo</h3>
                    <p>
                      No termina con la apertura. Hay soporte durante la puesta
                      en marcha y en la operación del día a día.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="ix">06</span>
                  <div>
                    <h3>Desarrollo de agentes</h3>
                    <p>
                      Un sistema para reclutar, formar y retener el equipo, que
                      es donde realmente se multiplica el negocio.
                    </p>
                  </div>
                </li>
              </ol>

              <div>
                <div
                  className="ph"
                  data-rv-ph=""
                  style={{ aspectRatio: "4/5" } as React.CSSProperties}
                >
                  <img
                    src="/franquicias/img/respaldo.webp"
                    alt="Sesión de capacitación de un equipo dentro de una oficina"
                    width="1200"
                    height="1500"
                    loading="lazy"
                    srcSet="/franquicias/img/respaldo-480.webp 480w, /franquicias/img/respaldo-800.webp 800w, /franquicias/img/respaldo-1200.webp 1200w"
                    sizes="(max-width: 760px) 100vw, 50vw"
                    decoding="async"
                  />
                </div>
                <p className="note" data-rv="">
                  <b>Sobre la inversión.</b> La apertura de una franquicia
                  requiere una inversión inicial. Las condiciones vigentes, el
                  desglose completo y los territorios disponibles se presentan
                  en la reunión, no por anuncio ni por correo. Es una decisión
                  de negocio y merece conversarse con la información completa.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="sec light" id="camino">
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">05</span> El camino
            </p>

            <div className="split">
              <h2 className="d2" data-rv="">
                Cuatro pasos entre
                <br />
                <em className="h-acc">hoy y tu oficina.</em>
              </h2>
              <p className="lead" data-rv="" data-rv-d="80">
                Sin letra pequeña y sin compromisos antes de tiempo. Cada paso
                existe para que ambas partes decidan con información real.
              </p>
            </div>

            <div
              className="split"
              style={
                {
                  marginTop: "var(--s7)",
                  alignItems: "start",
                } as React.CSSProperties
              }
            >
              <div className="path-wrap" id="pathWrap">
                <div className="step">
                  <span className="ix">Paso 01</span>
                  <h3>Solicitas la reunión</h3>
                  <p>
                    Respondes cuatro preguntas y eliges el día que te conviene.
                    Menos de un minuto.
                  </p>
                </div>
                <div className="step">
                  <span className="ix">Paso 02</span>
                  <h3>Reunión de presentación</h3>
                  <p>
                    Conoces el modelo completo, el respaldo que recibes y las
                    condiciones de inversión. Preguntas todo lo que necesites.
                  </p>
                </div>
                <div className="step">
                  <span className="ix">Paso 03</span>
                  <h3>Evaluación conjunta</h3>
                  <p>
                    Revisamos tu perfil, la zona que te interesa y la
                    disponibilidad de territorio. Aquí se decide si el modelo
                    encaja contigo y tú con él.
                  </p>
                </div>
                <div className="step">
                  <span className="ix">Paso 04</span>
                  <h3>Apertura y equipo</h3>
                  <p>
                    Adecuación del local, instalación de la tecnología,
                    capacitación e incorporación de tus primeros agentes.
                  </p>
                </div>
              </div>

              <div
                className="ph"
                data-rv-ph=""
                style={{ aspectRatio: "1/1" } as React.CSSProperties}
              >
                <img
                  src="/franquicias/img/reunion.webp"
                  alt="Reunión de presentación entre un representante y candidatos a franquicia"
                  width="1200"
                  height="1200"
                  loading="lazy"
                  srcSet="/franquicias/img/reunion-480.webp 480w, /franquicias/img/reunion-800.webp 800w, /franquicias/img/reunion-1200.webp 1200w"
                  sizes="(max-width: 760px) 100vw, 50vw"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="sec sec-800" id="reunion">
          <div className="glow" aria-hidden="true"></div>
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">06</span> Solicita tu reunión
            </p>

            <div className="form-grid">
              <aside className="form-aside">
                <h2 className="d2" data-rv="">
                  Lo que verás
                  <br />
                  <em className="h-acc">en la reunión.</em>
                </h2>
                <ul data-rv="" data-rv-d="80">
                  <li>
                    Conoces el modelo completo y qué incluye el respaldo de la
                    red
                  </li>
                  <li>
                    Revisas las condiciones de inversión con cifras concretas
                  </li>
                  <li>
                    Evalúas la disponibilidad de territorio en la zona que te
                    interesa
                  </li>
                </ul>
                <p className="sla" data-rv="" data-rv-d="140">
                  Un representante de REMAX República Dominicana confirma tu
                  reunión dentro de las próximas 24 horas. Tus datos se usan
                  únicamente para coordinar esta conversación.
                </p>
              </aside>

              <div className="card" data-rv="" data-rv-d="60">
                {withoutForm === null ? <div aria-busy="true" style={{ minHeight: 320 }} /> :
                  withoutForm ? <DirectCalendar /> : <FranchiseForm live={live} />}
              </div>
            </div>
          </div>
        </section>

        <section className="sec sec-700" id="faq">
          <div className="wrap">
            <p className="eyebrow" data-rv="">
              <span className="bar"></span>
              <span className="num">07</span> Preguntas frecuentes
            </p>
            <h2 className="d2" data-rv="">
              Lo que casi todos
              <br />
              preguntan primero.
            </h2>

            <div className="faq" data-rv="" data-rv-d="60">
              <details>
                <summary>
                  ¿Necesito experiencia en bienes raíces para abrir una
                  franquicia?
                </summary>
                <div className="a">
                  No. El dueño de oficina no vende propiedades: recluta,
                  organiza, lidera y hace crecer un equipo. Lo que se necesita
                  es visión, gestión y liderazgo. Buena parte de los perfiles
                  que mejor encajan vienen de banca, seguros, derecho, comercio
                  y otras profesiones liberales.
                </div>
              </details>
              <details>
                <summary>
                  ¿Cuál es la diferencia real entre ser agente y ser dueño de
                  oficina?
                </summary>
                <div className="a">
                  El agente trabaja dentro de una estructura que otro creó y sus
                  ingresos dependen del tiempo que él dedica. El dueño crea esa
                  estructura, define la cultura y construye un activo que le
                  pertenece, cuyo resultado crece con el equipo que multiplica.
                  Si lo que buscas es desarrollarte como agente, ese es otro
                  proceso y también está abierto.
                </div>
              </details>
              <details>
                <summary>¿Cuánto se necesita para abrir?</summary>
                <div className="a">
                  La apertura requiere una inversión inicial. Las condiciones
                  vigentes y el desglose completo se presentan en la reunión,
                  con las cifras validadas al momento de la conversación. En el
                  formulario preguntamos por rangos únicamente para preparar una
                  presentación ajustada a tu situación; ninguna respuesta te
                  descarta.
                </div>
              </details>
              <details>
                <summary>
                  ¿En qué zonas del país puedo abrir mi oficina?
                </summary>
                <div className="a">
                  La prioridad actual está en el interior del país: Santiago, La
                  Vega y Bonao, San Francisco de Macorís y el Nordeste, Puerto
                  Plata y la Costa Norte, y San Cristóbal y el Sur. El Este y el
                  Distrito Nacional también se atienden. La disponibilidad de
                  territorio en tu zona se confirma en la reunión.
                </div>
              </details>
              <details>
                <summary>
                  ¿Qué incluye exactamente el respaldo de la red?
                </summary>
                <div className="a">
                  Una marca reconocida, tecnología y CRM operativos desde el día
                  uno, capacitación estructurada para ti y para tus agentes,
                  acceso a la red global y regional, y acompañamiento continuo
                  durante la apertura y la operación. No compras un logo: entras
                  a una estructura que ya funciona.
                </div>
              </details>
              <details>
                <summary>¿Qué pasa después de que envío el formulario?</summary>
                <div className="a">
                  Un representante de REMAX República Dominicana te contacta
                  dentro de las próximas 24 horas para confirmar la reunión de
                  presentación en el horario que elegiste. Tus datos se usan
                  únicamente para coordinar esa conversación, según la{" "}
                  <a href="/politica-privacidad" target="_blank" rel="noopener noreferrer">
                    política de privacidad
                  </a>
                  .
                </div>
              </details>
            </div>
          </div>
        </section>

        <section className="final">
          <div className="final-bg" aria-hidden="true">
            <img
              src="/franquicias/img/cierre.webp"
              alt=""
              width="2400"
              height="1200"
              loading="lazy"
              srcSet="/franquicias/img/cierre-480.webp 480w, /franquicias/img/cierre-800.webp 800w, /franquicias/img/cierre-1200.webp 1200w"
              sizes="100vw"
              decoding="async"
            />
          </div>
          <div className="wrap">
            <img
              src="/franquicias/img/identificador_tu_diriges_geometrico_oficial-wht.webp"
              alt="Tú diriges. REMAX respalda."
              width="1107"
              height="810"
              loading="lazy"
              data-rv-clip=""
              decoding="async"
            />
            <h2 className="d2" data-rv="">
              La próxima historia
              <br />
              <em className="h-acc">
                puede <span className="acc">comenzar contigo</span>.
              </em>
            </h2>
            <p
              className="lead"
              data-rv=""
              data-rv-d="80"
              style={{ textAlign: "center" } as React.CSSProperties}
            >
              Empezó con una duda: querer emprender sin saber por dónde. Hoy hay
              un modelo probado del otro lado de una conversación de 45 minutos.
            </p>
            <a className="btn btn-1" href="#reunion" data-rv="" data-rv-d="140">
              Solicita tu reunión de presentación
              <svg
                className="arrow"
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 7h17M12 1l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="2.4"
                  strokeLinecap="square"
                ></path>
              </svg>
            </a>
          </div>
        </section>
      </main>

      <footer className="ft">
        <div className="wrap ft-in">
          <span className="logo-dark">
            <img
              src="/franquicias/img/logo-remax-neg.webp"
              alt="REMAX República Dominicana"
              width="1797"
              height="536"
              loading="lazy"
              decoding="async"
            />
          </span>
          <nav aria-label="Enlaces del pie de página">
            <a href="#modelo">El modelo</a>
            <a href="#perfil">¿Es para ti?</a>
            <a href="#faq">Preguntas frecuentes</a>
            <a href="/politica-privacidad" target="_blank" rel="noopener noreferrer">
              Política de privacidad
            </a>
            <a
              href="https://reclutamiento.remaxrd.com/?utm_source=landing_franquicias&utm_medium=footer&utm_id=campaign_franquicias"
              target="_blank"
              rel="noopener noreferrer"
            >
              Quiero ser agente
            </a>
          </nav>
          <p className="ft-legal">
            © <span id="yr">2026</span> REMAX República Dominicana. Cada oficina
            es de propiedad y operación independiente. Esta página presenta
            información general sobre el modelo de franquicia y no constituye
            una oferta de venta de franquicia. Las condiciones vigentes se
            entregan durante la reunión de presentación.
          </p>
        </div>
        <p className="developer-credit">
          DESARROLLADO POR <a href="http://version.do" target="_blank" rel="noopener noreferrer">VERSION DO</a>
        </p>
      </footer>
    </div>
  );
}
